import { render, staticRenderFns } from "./pswp.vue?vue&type=template&id=2bea43ba&"
import script from "./pswp.vue?vue&type=script&lang=js&"
export * from "./pswp.vue?vue&type=script&lang=js&"
import style0 from "./pswp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/d/Developments/Github/vue-photoswipe.js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bea43ba')) {
      api.createRecord('2bea43ba', component.options)
    } else {
      api.reload('2bea43ba', component.options)
    }
    module.hot.accept("./pswp.vue?vue&type=template&id=2bea43ba&", function () {
      api.rerender('2bea43ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/photoswipe/pswp.vue"
export default component.exports